module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/clickworker/preview_en-b6b2bf233b8f675ae9287e055049ec85.gif";